<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-lg-flex">
      <b-navbar-nav class="nav align-items-center ml-1 nav-date">
        <b-nav-item-dropdown
          left
          toggle-class="d-flex align-items-center dropdown-user-link"
          class="dropdown-projects"
        >
          <template #button-content>
            <b-img
              width="30"
              height="30"
              variant="light-primary"
              :src="`/${ projectName.toLowerCase().trim() }.png`"
            />
          </template>
          <b-dropdown-group v-if="userAccount && filteredUserProjects.length > 0">
            <b-dropdown-item
              v-for="userProject in filteredUserProjects"
              :key="`nav-menu-account-${userAccount.accountId}-project-${userProject.projectId}`"
              link-class="d-flex align-items-center"
              :to="{ name: 'project-frontend-dashboard-realtime', params: { account_id: userAccount.accountId, project_id: userProject.projectId }}"
            >
              <b-row>
                <b-col cols="4">
                  <b-img
                    width="30"
                    height="30"
                    variant="light-primary"
                    :src="`/${ userProject.projectName.toLowerCase().trim() }.png`"
                  />
                </b-col>
                <b-col
                  cols="7"
                  class="align-content-center"
                >
                  {{ userProject.projectName }}
                </b-col>
              </b-row>
            </b-dropdown-item>
          </b-dropdown-group>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-navbar-nav
        v-if="isVideo()"
        class="nav align-items-center ml-1 nav-date"
      >
        <feather-icon
          v-b-tooltip.hover
          size="16"
          icon="PlayCircleIcon"
          title="Video"
        />
        <b-nav-item
          :active="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-video-live')"
          :to="{ name: 'project-frontend-dashboard-video-live'}"
        >
          {{ liveTitle }}
        </b-nav-item>
        <b-nav-item
          :active="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-video-daily')"
          :to="{ name: 'project-frontend-dashboard-video-daily'}"
        >
          {{ dailyTitle }}
        </b-nav-item>
        <b-nav-item
          v-if="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-video-daily')"
        >
          <page-date-range-picker />
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav
        v-else-if="isQuery()"
        class="nav align-items-center ml-1 nav-date"
      >
        <feather-icon
          v-b-tooltip.hover
          size="16"
          icon="UserIcon"
          title="User Segments"
        />
        <b-nav-item
          :active="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-segment-user')"
          :to="{ name: 'project-frontend-dashboard-segment-user-list'}"
        >
          {{ userSegmentTitle }}
        </b-nav-item>
        <feather-icon
          v-b-tooltip.hover
          size="16"
          icon="FileTextIcon"
          title="Page Segments"
        />
        <b-nav-item
          :active="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-segment-page')"
          :to="{ name: 'project-frontend-dashboard-segment-page-list'}"
        >
          {{ pageSegmentTitle }}
        </b-nav-item>
        <feather-icon
          v-b-tooltip.hover
          size="16"
          icon="ApertureIcon"
          title="Actions"
        />
        <b-nav-item
          :active="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-segment-action-list')"
          :to="{ name: 'project-frontend-dashboard-segment-action-list'}"
        >
          {{ actionSegmentTitle }}
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav
        v-else
        class="nav align-items-center ml-1 nav-date"
      >
        <feather-icon
          v-b-tooltip.hover
          size="16"
          icon="BookOpenIcon"
          title="News"
        />
        <b-nav-item
          :active="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-realtime')"
          :to="{ name: 'project-frontend-dashboard-realtime'}"
        >
          {{ liveTitle }}
        </b-nav-item>
        <b-nav-item
          :active="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-30minutes')"
          :to="{ name: 'project-frontend-dashboard-30minutes'}"
        >
          {{ minutes30Title }}
        </b-nav-item>
        <b-nav-item
          :active="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-daily')"
          :to="{ name: 'project-frontend-dashboard-daily'}"
        >
          {{ dailyTitle }}
        </b-nav-item>
        <b-nav-item
          v-if="$route.matched.some(({ name }) => name === 'project-frontend-dashboard-daily')"
        >
          <page-date-range-picker />
        </b-nav-item>
        <b-nav-item
          :active="$route.matched.some(({ name }) => name.indexOf('project-frontend-dashboard-weekly') > -1 )"
          :to="{ name: 'project-frontend-dashboard-weekly'}"
        >
          {{ weeklyTitle }}
        </b-nav-item>
        <b-nav-item
          v-if="$route.matched.some(({ name }) => name.indexOf('project-frontend-dashboard-weekly') > -1 )"
        >
          <page-week-picker />
        </b-nav-item>
        <b-nav-item
          :active="$route.matched.some(({ name }) => name.indexOf('project-frontend-dashboard-monthly') > -1 )"
          :to="{ name: 'project-frontend-dashboard-monthly'}"
        >
          {{ monthlyTitle }}
        </b-nav-item>
        <b-nav-item
          v-if="$route.matched.some(({ name }) => name.indexOf('project-frontend-dashboard-monthly') > -1 )"
        >
          <page-month-picker />
        </b-nav-item>
      </b-navbar-nav>
    </div>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item
        :to="{ name: 'project-frontend-dashboard-realtime'}"
      >
        <feather-icon
          v-b-tooltip.hover
          size="16"
          icon="BookOpenIcon"
          class="mr-lg-2"
          title="News"
        />
      </b-nav-item>
      <b-nav-item
        :to="{ name: 'project-frontend-dashboard-video-live'}"
      >
        <feather-icon
          v-b-tooltip.hover
          size="16"
          icon="PlayCircleIcon"
          class="mr-lg-2"
          title="Video"
        />
      </b-nav-item>
      <b-nav-item
        v-if="$can('read', 'Report')"
        :to="{ name: 'project-frontend-dashboard-reports'}"
      >
        <feather-icon
          v-b-tooltip.hover
          size="16"
          icon="FileTextIcon"
          class="mr-lg-2"
          title="Reports"
        />
      </b-nav-item>
      <b-nav-item
        v-if="$can('read', 'Segment')"
        :to="{ name: 'project-frontend-dashboard-segment-user-list'}"
      >
        <feather-icon
          v-b-tooltip.hover
          size="16"
          icon="DatabaseIcon"
          class="mr-lg-2"
          title="Segmentation"
        />
      </b-nav-item>
      <b-nav-item
        v-if="$can('read', 'Report')"
        :to="{ name: 'project-frontend-dashboard-joint'}"
      >
        <feather-icon
          v-b-tooltip.hover
          size="16"
          icon="BoxIcon"
          class="mr-lg-2"
          title="Executive Summary"
        />
      </b-nav-item>
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ fullName }}
            </p>
            <span class="user-status">{{ role }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="avatar"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-group
          v-if="userAccounts && Object.entries(userAccounts).length > 1"
        >
          <b-dropdown-header>User Accounts</b-dropdown-header>
          <b-dropdown-item
            v-for="userAccountItem in userAccounts"
            :key="`nav-menu-account-${userAccountItem.accountId}-project-${userAccountItem.projectId}`"
            link-class="d-flex align-items-center"
            :to="{ name: 'project-frontend-dashboard-realtime',
                   params: {
                     account_id: userAccountItem.accountId,
                     project_id: userAccountItem.userProjects ? Object.values(userAccountItem.userProjects)[0].projectId : ''
                   }
            }"
          >
            <b-row>
              <b-col
                class="align-content-center"
              >
                <feather-icon
                  size="16"
                  icon="ApertureIcon"
                  class="mr-50"
                />
                {{ userAccountItem.accountName }}
              </b-col>
            </b-row>
          </b-dropdown-item>
          <b-dropdown-divider />
        </b-dropdown-group>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          :to="{name: 'user-account-setting'}"
        >
          <feather-icon
            size="16"
            icon="SettingsIcon"
            class="mr-50"
          />
          <span>Settings</span>
        </b-dropdown-item>
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <dark-Toggler class="d-none d-lg-block" />
      <b-nav-item-dropdown
        v-if="$can('read', 'AccountUser')"
        variant="link"
        toggle-class="text-decoration-none"
        no-caret
        right
        menu-class="mt-2"
      >
        <template v-slot:button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="16"
            class="text-body align-middle"
          />
        </template>
        <b-dropdown-item
          link-class="d-flex align-items-center"
          :to="{name: 'account-user-list'}"
        >
          <feather-icon
            size="16"
            icon="SettingsIcon"
            class="mr-50"
          />
          <span>Account Users</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
    BNavbarNav, BNavItem, BNavItemDropdown, BDropdownItem, BAvatar, BDropdownGroup, BRow, BCol, BImg, BDropdownDivider, BDropdownHeader, VBTooltip,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import PageDateRangePicker from '@/views/components/filters/PageDateRangePicker.vue'
import PageWeekPicker from '@/views/components/filters/PageWeekPicker.vue'
import PageMonthPicker from '@/views/components/filters/PageMonthPicker.vue'

import {
    getUserFullName,
    getUserCurrentRole,
    getUserAvatar,
    getUserAccounts,
    getCurrentAccountData,
    logout, getCurrentProjectData,
} from '@/auth/utils'
import userSegment from '@/views/apps/project-frontend/dashboard/segment/UserSegmentList.vue'

export default {
    components: {
        BNavbarNav,
        BNavItem,
        BNavItemDropdown,
        BDropdownItem,
        BDropdownGroup,
        BAvatar,
        // Navbar Components
        BRow,
        BCol,
        DarkToggler,
        PageDateRangePicker,
        PageWeekPicker,
        PageMonthPicker,
        BImg,
        BDropdownDivider,
        BDropdownHeader,
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    props: {
        toggleVerticalMenuActive: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        const isMobile = this.isMobile()
        const liveTitle = isMobile ? 'L' : 'Live'
        const minutes30Title = isMobile ? '30M' : '30 Min'
        const weeklyTitle = isMobile ? 'W' : 'Weekly'
        const monthlyTitle = isMobile ? 'M' : 'Monthly'
        const dailyTitle = isMobile ? 'D' : 'Daily'
        const reportTitle = isMobile ? 'R' : 'Report'
        const userSegmentTitle = isMobile ? 'US' : 'User Segments'
        const pageSegmentTitle = isMobile ? 'PS' : 'Page Segments'
        const actionSegmentTitle = isMobile ? 'QC' : 'Actions'

        return {
            projectName: this.getProjectName(),
            liveTitle,
            minutes30Title,
            weeklyTitle,
            monthlyTitle,
            dailyTitle,
            reportTitle,
            userSegmentTitle,
            pageSegmentTitle,
            actionSegmentTitle,
            userAccount: getCurrentAccountData(),
        }
    },
    computed: {
        userSegment() {
            return userSegment
        },
        fullName: getUserFullName,
        role: getUserCurrentRole,
        avatar: getUserAvatar,
        userAccounts: getUserAccounts,
        filteredUserProjects() {
            if (this.userAccount && this.userAccount.userProjects) {
                return Object.values(this.userAccount.userProjects).filter(project => !project.projectName.toLowerCase().includes('secim'))
            }
            return []
        },
    },
    watch: {
        $route() {
            this.projectName = this.getProjectName()
            this.userAccount = getCurrentAccountData()
        },
    },
    methods: {
        logout,
        getProjectName() {
            const currentProjectData = getCurrentProjectData()

            // console.log("currentProjectData", currentProjectData)
            let projectName = ''
            if (currentProjectData) {
                projectName = currentProjectData.projectName
            }
            return projectName
        },
        isMobile() {
            return window.innerWidth < 768
        },
        isVideo() {
            return this.$route.matched.some(({ name }) => name.indexOf('video') > -1)
        },
        isQuery() {
            return this.$route.matched.some(({ name }) => name.indexOf('segment') > -1)
        },
        mapProjectName(projectName) {
            let projectNameMapped = projectName
            // eslint-disable-next-line default-case
            switch (projectName) {
            case 'HurriyetSecim':
                projectNameMapped = 'Hurriyet<br/>Secim'
                break
            case 'MilliyetSecim':
                projectNameMapped = 'Milliyet<br/>Secim'
                break
            case 'CnnturkSecim':
                projectNameMapped = 'Cnnturk<br/>Secim'
                break
            case 'PostaSecim':
                projectNameMapped = 'Posta<br/>Secim'
                break
            case 'VatanSecim':
                projectNameMapped = 'Vatan<br/>Secim'
                break
            }

            return projectNameMapped
        },
        // mapProjectName(projectName) {
        //     let projectNameMapped = projectName
        //     // eslint-disable-next-line default-case
        //     switch (projectName) {
        //     case 'HurriyetSecim':
        //         projectNameMapped = 'Hurriyet<br/>Secim'
        //         break
        //     case 'MilliyetSecim':
        //         projectNameMapped = 'Milliyet<br/>Secim'
        //         break
        //     case 'CnnturkSecim':
        //         projectNameMapped = 'Cnnturk<br/>Secim'
        //         break
        //     case 'PostaSecim':
        //         projectNameMapped = 'Posta<br/>Secim'
        //         break
        //     case 'VatanSecim':
        //         projectNameMapped = 'Vatan<br/>Secim'
        //         break
        //     }
        //
        //     return projectNameMapped
        // },
    },
}
</script>

<style>
.dropdown-projects .dropdown-menu {
  padding-right: 3rem;
  overflow-x: hidden;
  width: auto;
  max-width: 100vw;
}
</style>
